/** Paging for a users response; the workspace route sends none, so the list is one page. */
export const pagingOf = (response, pageSize) => {
  const users = response.users ?? [];
  const p = response.pagination ?? {
    current_page: 1,
    prev_page: null,
    total_records: users.length,
    total_pages: 1
  };
  return {
    pageIndex: p.current_page,
    pageSize,
    totalRecords: Number(p.total_records) || 0,
    nextPage: p.current_page,
    prevPage: p.prev_page,
    totalPages: p.total_pages
  };
};
